// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".idLSeAM8gYv_cRAsqSmq{padding-top:40px;padding-bottom:20px;display:flex;flex-direction:column;align-items:center}@media(min-width: 1024px){.idLSeAM8gYv_cRAsqSmq{padding-top:60px;padding-bottom:30px}}.Y3iy8d9DM7fnxKXullVr{margin-bottom:16px}.oS56Xitpp0KfXjbMeGxF{color:#f56565;font-size:21px;font-weight:bold;text-align:center;text-transform:uppercase;margin-bottom:14px}@media(min-width: 1024px){.oS56Xitpp0KfXjbMeGxF{font-size:30px}}.BIbQupx_LZw_nOsMEFGz{max-width:500px;text-align:center;color:#5b6473}@media(min-width: 1024px){.BIbQupx_LZw_nOsMEFGz{font-size:20px}}.BIbQupx_LZw_nOsMEFGz a{color:#1874fd;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notfound": "idLSeAM8gYv_cRAsqSmq",
	"notfoundImage": "Y3iy8d9DM7fnxKXullVr",
	"notfoundTitle": "oS56Xitpp0KfXjbMeGxF",
	"notfoundDescription": "BIbQupx_LZw_nOsMEFGz"
};
export default ___CSS_LOADER_EXPORT___;
